import React from "react";

const AgencyHome = () => {
  return <h1>AGENCY HOME</h1>;
};

export default AgencyHome;
